import { put, takeLatest, call, fork } from "redux-saga/effects";
import APP_URL from "../../Constants/AppUrl";
import ACTIONS from "./ProformaActionsType";
import axios from "axios";
import { showNotification } from "../../Utils/CommonFunctions";

const createProformaApi = (data) => {
    return axios({
        method: "POST",
        url: APP_URL.PROFORMA_URL,
        data: data,
    });
};

function* createProforma(action) {
    try {
        let response = yield call(createProformaApi, action.payload);
        let resData = response?.data;
        if (resData?.success === false) {
            showNotification("error", resData?.message || resData?.message);
            yield put({
                type: ACTIONS.CREATE_FAIL,
                payload: resData,
            });
        } else {
            showNotification("success", resData?.message);
            yield put({
                type: ACTIONS.CREATE_SUCCESS,
                proforma: resData.proforma,
            });
        }
    } catch (error) {
        console.log("Create Proforma ", error);
    }
}

const fetchAllProformasApi = (params) => {
    return axios({
        method: "GET",
        url: APP_URL.PROFORMA_URL,
        params: params,
    });
};

function* fetchAllProformas(action) {
    try {
        let response = yield call(fetchAllProformasApi, action.payload);
        let resData = response?.data;
        if (resData?.success === false) {
            showNotification("error", resData?.message);
            yield put({
                type: ACTIONS.FETCH_ALL_FAIL,
                payload: resData,
            });
        } else {
            let payload = resData || {};
            payload.isReset = action?.payload?.offset === 0;
            yield put({
                type: ACTIONS.FETCH_ALL_SUCCESS,
                payload: payload,
            });
        }
    } catch (error) {
        console.log("Fetch Proformas ", error);
    }
}


const updateProformaApi = (data) => {
    return axios({
        method: "PUT",
        url: `${APP_URL.PROFORMA_URL}/${data?._id}`,
        data: data,
    });
};

function* updateProforma(action) {
    try {
        let response = yield call(updateProformaApi, action.payload);
        let resData = response?.data;
        console.log(resData, 'ProformaRes')
        if (resData?.success === false) {
            showNotification("error", resData?.message || resData?.message);
            yield put({
                type: ACTIONS.UPDATE_FAIL,
                payload: resData,
            });
        } else {
            showNotification("success", resData?.message);
            yield put({
                type: ACTIONS.UPDATE_SUCCESS,
                proforma: resData?.proforma,
            });
        }
    } catch (error) {
        console.log("Update Proforma ", error);
    }
}

const deleteProformaApi = (id) => {
    return axios({
        method: "DELETE",
        url: `${APP_URL.PROFORMA_URL}/${id}`,
    });
};

function* deleteProforma(action) {
    try {
        let response = yield call(deleteProformaApi, action.id);
        let resData = response?.data;

        if (resData?.success === false) {
            yield put({
                type: ACTIONS.DELETE_FAIL,
                payload: resData,
            });
        } else {
            showNotification("success", resData?.message);
            yield put({
                type: ACTIONS.DELETE_SUCCESS,
                id: action.id,
            });
        }
    } catch (error) {
        console.log("Delete Proforma ", error);
    }
}

function* watchProformas() {
    yield takeLatest(ACTIONS.CREATE_REQUEST, createProforma);
    yield takeLatest(ACTIONS.FETCH_ALL_REQUEST, fetchAllProformas);
    yield takeLatest(ACTIONS.UPDATE_REQUEST, updateProforma);
    yield takeLatest(ACTIONS.DELETE_REQUEST, deleteProforma);

}

// ACTION WATCHER
export default function* ProformaSaga() {
    yield fork(watchProformas);
}
